import { PRO_TASK_QNR_VERSION_EXT_URL } from "../models/types";

const EXT_URL = PRO_TASK_QNR_VERSION_EXT_URL;

export const extractQnrVersionExt = (
  responseResource: fhir.QuestionnaireResponse
): string => {
  if (!responseResource.hasOwnProperty("extension")) {
    return "N/A";
  }
  const ext = responseResource.extension.find(
    elem => elem.url === EXT_URL
  ) as fhir.Extension;
  if (ext === undefined) {
    return "N/A";
  }
  return ext.valueString;
};



// WEBPACK FOOTER //
// ./src/app/utils/extract-qnr-version-ext.ts